"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, Vue, Ref } from "vue-property-decorator";
import GridSelector from "@/components/dialog/GridSelector.vue";
import UiDialog, { UiDialogController } from "@/components/dialog/UiDialog.vue";
import _ from "lodash";
import API from "@ym-framework/api-utils";
let DepartmentsChooseDialog = class extends Vue {
  constructor() {
    super(...arguments);
    this.departmentList = [];
    this.departmentProps = {
      label: "label",
      children: "children"
    };
    this.byDepartmentselectDatas = [];
    this.byDepartmentselectLock = false;
    this.activeName = "first";
    this.searchStrbyDepartment = "";
    this.dialog = new UiDialogController();
  }
  open(datas) {
    return __async(this, null, function* () {
      this.dialog.visible = true;
      this.$nextTick(() => __async(this, null, function* () {
        yield this.getDepartmentTrees();
        if (datas) {
          this.byDepartmentselectDatas = datas;
          for (let data of datas) {
            this._departmentTree.setChecked(data.id, true);
          }
        }
      }));
    });
  }
  getDepartmentTrees() {
    return __async(this, null, function* () {
      try {
        let arr = [];
        let response = yield API.get(`api://base.auth/api/v7/departments`);
        arr.push(response.data);
        this.departmentList = arr;
        this.byDepartmentcheckItem();
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  filterNode(value, data) {
    if (!value)
      return true;
    return data.label.indexOf(value) !== -1;
  }
  byDepartmentcheckItem() {
    var _a;
    let selectDatas = (_a = this._byDepartmentsGridSelector) == null ? void 0 : _a.getAll();
    let rows = _.intersectionWith(
      this.departmentList,
      selectDatas,
      (selectData, data) => selectData.id == data.id
    );
    this.byDepartmentselectLock = true;
    if (rows) {
      for (const row of rows) {
        this._departmentTree.setChecked(row.id, true);
      }
    }
    this.byDepartmentselectLock = false;
  }
  byDepartmentChanged(data) {
    console.log(data);
    if (data && data.length > 0) {
      let rows = _.differenceWith(
        this.byDepartmentselectDatas,
        data,
        (selectData, data2) => selectData.id == data2.id
      );
      this.byDepartmentselectLock = true;
      if (rows) {
        for (const row of rows) {
          let item = this.byDepartmentselectDatas.find(function(value) {
            return value.id === row.id;
          });
          this._departmentTree.setChecked(row.id, false);
        }
      }
      this.byDepartmentselectLock = false;
    } else {
      this.byDepartmentselectDatas = [];
      let checkedIds = this._departmentTree.getCheckedKeys();
      for (const id of checkedIds) {
        this._departmentTree.setChecked(id, false);
      }
    }
  }
  byDepartmentSearchName(searchStr) {
    return __async(this, null, function* () {
      this._departmentTree.filter(searchStr);
    });
  }
  handleCheckChange(data, isChecked) {
    if (isChecked) {
      this.byDepartmentselectDatas.push(data);
      let new_data = {
        id: data.id,
        label: data.label
      };
      this._byDepartmentsGridSelector.add(new_data);
    } else {
      let item = this.byDepartmentselectDatas.find(function(value) {
        return value.id === data.id;
      });
      if (item) {
        let new_data = {
          id: item.id,
          label: item.label
        };
        this.byDepartmentselectDatas.splice(item, 1);
        this._byDepartmentsGridSelector.del(new_data);
      }
    }
  }
  cancel() {
    this.dialog.visible = false;
    this.$emit("close");
  }
  confirm(datas) {
    try {
      this.$emit("change", datas);
      this.dialog.visible = false;
    } catch (error) {
      if (error.hasOwnProperty("response")) {
        this.$message.error(error.response.data.errors.datas[0].message);
      }
    }
  }
};
__decorateClass([
  Ref("byDepartmentsGridSelector")
], DepartmentsChooseDialog.prototype, "_byDepartmentsGridSelector", 2);
__decorateClass([
  Ref("department-tree")
], DepartmentsChooseDialog.prototype, "_departmentTree", 2);
DepartmentsChooseDialog = __decorateClass([
  Component({
    components: {
      UiDialog,
      GridSelector
    }
  })
], DepartmentsChooseDialog);
export {
  DepartmentsChooseDialog as default
};
